"use client";

import {
  agentsFiltersAtom,
  type AgentSortOption,
} from "@/app/(saas)/(app)/business-brokers/_components/filters/state";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { useAtom } from "jotai";
import { useState } from "react";

const SORT_OPTIONS: Array<{ value: AgentSortOption; label: string }> = [
  { value: "recommended", label: "Relevance" },
  { value: "most_active", label: "Most Active" },
  { value: "highest_rated", label: "Highest Rated" },
  { value: "most_experienced", label: "Most Experienced" },
  { value: "most_reviews", label: "Most Reviews" },
];

export function AgentSortDropdown() {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useAtom(agentsFiltersAtom);

  const currentLabel =
    SORT_OPTIONS.find((o) => o.value === filters.sort)?.label ?? "Relevance";

  function handleSort(sort: AgentSortOption) {
    setFilters((prev) => ({ ...prev, sort, page: 1 }));
    setOpen(false);
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="h-9 rounded-full text-sm px-4 border-[var(--venturu-gray-100)] hover:border-[var(--venturu-gray-300)]"
        >
          <span className="text-[var(--venturu-gray-500)] mr-1">Sort:</span>
          {currentLabel}
          <Icon icon="ChevronDown" className="size-3.5 ml-1" />
        </Button>
      </PopoverTrigger>

      <PopoverContent align="end" className="w-48 p-1">
        {SORT_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => handleSort(option.value)}
            className={cn(
              "w-full text-left px-3 py-2 text-sm rounded-md transition-colors",
              filters.sort === option.value
                ? "bg-[var(--venturu-gray-50)] font-medium text-[var(--venturu-black)]"
                : "text-[var(--venturu-gray-500)] hover:bg-[var(--venturu-gray-50)] hover:text-[var(--venturu-black)]",
            )}
          >
            {option.label}
            {filters.sort === option.value && (
              <Icon icon="CheckSolid" className="inline-block ml-2 size-3.5" />
            )}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
